import script from "./dupliPopUp6.vue?vue&type=script&setup=true&lang=js"
export * from "./dupliPopUp6.vue?vue&type=script&setup=true&lang=js"

import "./dupliPopUp6.vue?vue&type=style&index=0&id=3485b9c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3485b9c0"]])

export default __exports__